// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__Q5C3_","spinner":"Loader_spinner__WWuKC","error":"Loader_error__KrM2B"};